module.exports = __webpack_public_path__ + "static/media/header-curves-bg.8f269575.png";